import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import type { User } from './user';

/**
 * useUser hook - integrates with Azure AD authentication
 * Returns user data compatible with existing UI components
 */
export default function useUser() {
	const { user, userProfile, isLoading, error, logout, isAuthenticated } = useAuth();

	// Transform user data to match expected User type for UI components
	const transformedUser: User | null = useMemo(() => {
		if (!user || !userProfile) return null;

		return {
			id: userProfile.id.toString(),
			fullName: userProfile.fullName,
			displayName: userProfile.displayName || userProfile.fullName,
			email: userProfile.email,
			photoURL: '',
			role: userProfile.roles?.[0]?.roleName?.toLowerCase(), // Primary role as string
			roles: userProfile.roles?.map((r) => ({ name: r.roleName })), // Map RoleDto to role objects
			settings: {
				layout: {
					style: 'layout1',
					config: {
						navbar: {
							style: 'style-2',
							folded: false,
							position: 'left',
						},
					},
				},
			},
		};
	}, [user, userProfile]);

	return {
		data: transformedUser,
		isLoading,
		error: error ? new Error(error) : null,
		isGuest: !isAuthenticated,
		signOut: logout,
		updateUser: (userData: Partial<User>) => {
			console.log('Update user settings:', userData);
			// TODO: Implement user settings update
			// This would update local preferences, not Azure AD profile
		},
	};
}
